import { useRecoilValue } from 'recoil';

import { pm } from 'lib/helpers/utility';

import { permissions as permissionsState } from 'components/state';

const useCanViewPractices = () => !!pm(useRecoilValue(permissionsState), 'practice.read');

export default useCanViewPractices;
